import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { GetDashboardDeletedAccountsChartData } from "../../../utils/api";
import { message } from "antd";
import { constructParams } from "./constructParams";
import Loader from "../../shared/Loader";

const options = {
  responsive: true,
  cutout: "85%",
  plugins: {
    legend: {
      display: false,
    },
  },
  layout: {
    padding: 20,
  },
  annotation: {
    annotations: [
      {
        drawTime: "afterDatasetsDraw",
        type: "text",
        id: "text-center",
        x: "50%",
        y: "50%",
        fontColor: "#000",
        text: "Center Text",
        fontSize: 12,
      },
    ],
  },
};

const AccountsDeletedChart = ({ selectedOption, startDate, endDate }) => {
  const [accountsDeleted, setAccountsDeleted] = useState({});

  const [loading, setLoading] = useState(true);

  const fetch = async (params) => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams(params).toString();
      const response = await GetDashboardDeletedAccountsChartData(queryParams);
      setAccountsDeleted(response?.items);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error(error || "Unknown error occured. Please try again later.");
    }
  };

  useEffect(() => {
    const params = constructParams(selectedOption, startDate, endDate);
    fetch(params);
  }, [selectedOption, startDate, endDate]);

  const accountsDeletedData = {
    labels: ["Clients", "Service Providers"],
    datasets: [
      {
        data: [
          accountsDeleted?.clientDeletedAccounts,
          accountsDeleted?.spDeletedAccounts,
        ],
        backgroundColor: ["#FFC400", "#56D863"],
      },
    ],
  };

  return (
    <div className="sm:w-4/12 w-full flex-1 p-4 box-shadow rounded-xl">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold">Accounts Deleted</h2>
      </div>
      <div className="w-full flex flex-col">
        <div className="w-64 h-64 ml-auto total-deleted relative">
          <div
            className={`absolute top-[75px] left-[68px] flex flex-col items-center text-center ${
              loading ? "hidden" : "flex"
            }`}
          >
            <span className="text-3xl font-bold">
              {accountsDeleted?.totalDeletedAccount}
            </span>
            <span className="text-2xl font-semibold">
              Accounts <br /> Deleted
            </span>
          </div>
          {loading ? (
            <Loader height="h-[40vh]" />
          ) : (
            <Doughnut data={accountsDeletedData} options={options} />
          )}
        </div>
        <div className="-mt-10 flex flex-col gap-y-3">
          <div className="flex gap-x-1 items-center">
            <div className="w-2 h-2 rounded-full bg-yellow-900" />
            <span className="2xl:text-sm text-[10px] font-bold mr-1">
              {accountsDeleted?.clientDeletedAccounts}
            </span>
            <p className="text-[10px] 2xl:text-sm text-black-500">Clients</p>
          </div>
          <div className="flex gap-x-1 items-center">
            <div className="w-2 h-2 rounded-full bg-green" />
            <span className="text-[10px] 2xl:text-sm font-bold mr-1">
              {accountsDeleted?.spDeletedAccounts}
            </span>
            <p className="text-[10px] 2xl:text-sm text-black-500">
              Service Providers
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountsDeletedChart;
